// extracted by mini-css-extract-plugin
export var link = "_tk-0";